import { render, staticRenderFns } from "./DealSupplierIdentityVerificationAction.vue?vue&type=template&id=0fb929f8&scoped=true"
import script from "./DealSupplierIdentityVerificationAction.vue?vue&type=script&lang=js"
export * from "./DealSupplierIdentityVerificationAction.vue?vue&type=script&lang=js"
import "./DealSupplierIdentityVerificationAction.vue?vue&type=style&index=0&id=0fb929f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb929f8",
  null
  
)

export default component.exports